// load the inline styles
var inlineCss = ".te-pro-gallery-text-item {\n  font:;{{Body-S}};\n  color: {{color-1}}\n}\n.pro-gallery-sharedialog #sharedialog-content .sharer-dialog-wrapper .sharer-dialog-subtitle {\n  font:;{{style.itemDescriptionFont Body-M}};\n}\n.pro-gallery-sharedialog #sharedialog-content .sharer-dialog-wrapper .sharer-dialog-title {\n  font:;{{style.itemFont Body-M}};\n}\n.pro-gallery-sharedialog #sharedialog-content .sharer-dialog-wrapper .sharer-dialog-input-container .sharer-dialog-input {\n  font:;{{style.itemDescriptionFont Body-M}};\n}\n.pro-gallery-sharedialog #sharedialog-content .sharer-dialog-wrapper .sharer-dialog-icons:after {\n  font:;{{style.itemDescriptionFont Body-M}};\n}";
require("!../../../node_modules/wix-tpa-style-loader/dist/src/addStyles.js")(inlineCss);
if(module.hot) {
  module.hot.accept();
  if(document.querySelector('style[hot-reloaded]') && window.Wix) {
    window.Wix.Styles.getStyleParams(function(style){
      window.postMessage(JSON.stringify({intent: 'addEventListener', eventType:window.Wix.Events.STYLE_PARAMS_CHANGE, params:{style: style}}), '*')
    })
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-tpa-style-loader/dist/src?mode=inline!../node_modules/sass-loader/lib/loader.js?{"includePaths": [".", "node_modules"]}!./assets/styles/injected-style-multishare.global.scss
// module id = 292
// module chunks = 31 33